import { render, staticRenderFns } from "./CreateGoodsAddress.vue?vue&type=template&id=2db3b636&scoped=true&"
import script from "./CreateGoodsAddress.vue?vue&type=script&lang=js&"
export * from "./CreateGoodsAddress.vue?vue&type=script&lang=js&"
import style0 from "./CreateGoodsAddress.vue?vue&type=style&index=0&id=2db3b636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3b636",
  null
  
)

export default component.exports